import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFilePowerpoint } from "@fortawesome/free-solid-svg-icons";

function Stage() {
  return (
    <section id="stage" className="my-5 p-5">
      <div className="container">
        {/* Title Section */}
        <h1 className="text-center mb-4 mt-3">
          Automatiseren van Vertalingen en Dashboardvisualisaties in React
        </h1>

        {/* Context Section */}
        <div className="mb-4">
          <h2 className="fw-bold">Context</h2>
          <p>
            Ik heb stage gelopen bij <strong>Van Genechten Packaging</strong>,
            waar ik heb gewerkt aan een <strong>vertalingsoplossing</strong> en aan een
            applicatie voor <strong>Grafana-dashboards</strong>. Deze projecten
            waren gericht op het stroomlijnen van interne processen en het
            verbeteren van de toegankelijkheid en efficiëntie binnen het
            bedrijf. Deze ervaring stelde mij in staat om mijn technische
            vaardigheden verder te ontwikkelen en mijn professionele groei te
            bevorderen.
          </p>
        </div>

        {/* What I Did Section */}
        <div className="mb-4">
          <h2 className="fw-bold">Wat heb ik gedaan</h2>
          <p>
            Tijdens mijn stage realiseerde ik <strong>twee projecten</strong>:
            <ul>
              <li>
                <strong>Translationsproject</strong>: Ik ontwikkelde een proces
                om volledige woorden en zinnen te vertalen naar meerdere talen.
                Deze vertalingen werden automatisch toegevoegd aan een centrale
                database, wat het beheer en gebruik van vertalingen aanzienlijk
                vereenvoudigde.
              </li>
              <li>
                <strong>Grafana-dashboardproject</strong>: Ik ontwierp een
                applicatie om alle Grafana-dashboards overzichtelijk op een
                centrale pagina weer te geven.
              </li>
            </ul>
          </p>
        </div>

        {/* Outcomes Section */}
        <div className="mb-4">
          <h2 className="fw-bold">Uitkomsten</h2>
          <p>
            De projecten leverden directe voordelen op:
            <ul>
              <li>
                Het translations-project verbeterde de consistentie en snelheid
                van het vertalen binnen het bedrijf.
              </li>
              <li>
                Het Grafana-dashboardproject zorgde voor een betere
                toegankelijkheid en overzichtelijkheid van belangrijke gegevens.
              </li>
            </ul>
          </p>
          <p>
            Voor beide projecten heb ik een <strong>offcanvas-component</strong>{" "}
            gemaakt:
            <ul>
              <li>
                Bij het translations-project konden vertalingen worden bekeken
                en aangepast, gefilterd op de geselecteerde taal.
              </li>
              <li>
                Bij het Grafana-dashboardproject zorgde de offcanvas-component
                ervoor dat dashboards werden gefilterd op omgeving (
                <strong>SIT, UAT, PRD</strong>). Bij afwezigheid van dashboards
                kon men doorklikken naar een algemene overzichtspagina.
              </li>
            </ul>
          </p>
        </div>

        {/* Experience Section */}
        <div className="mb-4">
          <h2 className="fw-bold">Mijn ervaring</h2>
          <p>
            Mijn stage was een waardevolle leerervaring. Ik ontwikkelde mijn
            vaardigheden in:
            <ul>
              <li>
                Effectieve communicatie, zoals het organiseren en presenteren
                tijdens meetings.
              </li>
              <li>
                Precisie, door mijn code grondig te testen en controleren vóór
                het pushen naar <strong>GitHub</strong>.
              </li>
              <li>
                Documentatiestructuur, door structuur aan te brengen in mijn
                code en onnodige elementen efficiënt te verwijderen.
              </li>
            </ul>
          </p>
        </div>

        {/* Bewijsstukken Section */}
        <div className="mb-4 p-3 bg-light border rounded">
          <h2 className="fw-bold">Bewijsstukken</h2>
          <p>
            Bekijk hier enkele belangrijke documenten en voorbeelden van mijn
            werk:
          </p>
          <ul className="list-unstyled">
            <li>
              <a
                href="/powerpoint_plan_van_aanpak.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-link"
              >
                <strong>Plan van aanpak: </strong>
                <FontAwesomeIcon icon={faFilePowerpoint} /> Plan van aanpak
                stage
              </a>
            </li>
            <li>
              <a
                href="/Realisatie_document_stage.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-link"
              >
                <strong>Realisatie: </strong>
                <FontAwesomeIcon icon={faFilePdf} /> Realisatie documentatie
              </a>
            </li>
            <li>
              <a
                href="/Reflectie_document_stage.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-link"
              >
                <strong>Reflectie: </strong>
                <FontAwesomeIcon icon={faFilePdf} /> Reflectie over de stage
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Stage;
